import { usePluginConfig } from "../contexts/pluginContext";

/*
    This hook is an adapter to ease the transition from Redux to React Context.
 */
export const useSelector = (func) => {
	const pluginConfig = usePluginConfig();
	return func(pluginConfig);
};
